export default __webpack_public_path__ + "static/media/prev.f376f4b1.svg";